export const PUSH_MESSAGE_TYPES = {
  new_voice_call: 'new_voice_call',
  join_video_room: 'join_video_room',
  answered_call: 'answered_call',
  merge_video_call: 'merge_video_call',
  call_ended: 'call_ended',
  put_on_hold: 'put_on_hold',
  active_in_conference: 'active_in_conference',
  video_ended: 'video_ended',
}
